module.exports = __webpack_public_path__ + "static/media/kn.6819c37b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/kn.svg
// module id = 690
// module chunks = 0